var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_51",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3119",
    "data-name": "Rectangle 3119",
    width: 35.801,
    height: 33.477,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9344",
    "data-name": "Group 9344",
    transform: "translate(9.242 6.098)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.24, -6.1)",
    filter: "url(#Ellipse_51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51-2",
    "data-name": "Ellipse 51",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11223",
    "data-name": "Group 11223",
    transform: "translate(24.794 26.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9208",
    "data-name": "Group 9208",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M66.8,106.864l-.154-.165A7,7,0,0,1,65,103.878a6.6,6.6,0,0,1-.261-2.147A6.369,6.369,0,0,1,65.7,98.7a6.906,6.906,0,0,1,1.862-1.9,5.9,5.9,0,0,1,2.887-1.067,6.065,6.065,0,0,1,3.876.755,6.434,6.434,0,0,1,3.191,4.515,5.807,5.807,0,0,1-.137,2.826,6.653,6.653,0,0,1-1.527,2.686c-.051.054-.1.111-.15.163s-.108.1-.185.17a2,2,0,0,0,.19.1,11.181,11.181,0,0,1,3.938,2.761,10,10,0,0,1,1.658,2.266,12.424,12.424,0,0,1,1.33,3.879,2.6,2.6,0,0,1-1.1,2.6,2.325,2.325,0,0,1-1.088.387,4.63,4.63,0,0,1-.682.042q-8.634,0-17.268,0a2.752,2.752,0,0,1-1.821-.575,2.533,2.533,0,0,1-.977-2.13,7.617,7.617,0,0,1,.415-2.041,11.505,11.505,0,0,1,3.771-5.536,9.9,9.9,0,0,1,2.188-1.38c.237-.107.467-.228.736-.361M80.1,116.3c-.023-.126-.04-.224-.06-.321a11.934,11.934,0,0,0-.732-2.271,7.821,7.821,0,0,0-1.033-1.625,8.482,8.482,0,0,0-2.906-2.436,9,9,0,0,0-5.359-.957,8.543,8.543,0,0,0-2.742.816,9,9,0,0,0-3.047,2.391,9.853,9.853,0,0,0-1.3,2.073,8.435,8.435,0,0,0-.587,1.875c-.03.146-.043.3-.066.454ZM71.178,98.3a3.845,3.845,0,1,0,3.843,3.817A3.83,3.83,0,0,0,71.178,98.3",
    transform: "translate(-53.283 -85.41)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M247.8,116.863c.08.046.14.085.2.116a8.8,8.8,0,0,1,2.442,1.777,9.04,9.04,0,0,1,2.275,4.033,4.75,4.75,0,0,1,.161.889,2.558,2.558,0,0,1-2.286,2.6,5.99,5.99,0,0,1-1.664-.008,1.217,1.217,0,0,1-1.017-.965,1.178,1.178,0,0,1,.427-1.275,1.506,1.506,0,0,1,.946-.281c.261-.013.523,0,.785,0h.226c-.045-.178-.073-.328-.119-.472a6.377,6.377,0,0,0-4.7-4.49c-.245-.065-.486-.149-.731-.215-.122-.033-.25-.043-.376-.063a1.309,1.309,0,0,1-1.059-1.647,1.217,1.217,0,0,1,.871-.845,8.314,8.314,0,0,0,.824-.249,2.519,2.519,0,0,0,1.54-2.423,2.545,2.545,0,0,0-1.93-2.368,3.791,3.791,0,0,1-.557-.165,1.327,1.327,0,0,1-.851-1.043,1.124,1.124,0,0,1,.315-.979,1.439,1.439,0,0,1,1.454-.4,5.043,5.043,0,0,1,2.6,1.393,4.807,4.807,0,0,1,1.038,1.4,5,5,0,0,1,.148,4.131,5.2,5.2,0,0,1-.968,1.561",
    transform: "translate(-217.085 -96.705)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M2.579,123.744c.126,0,.231,0,.336,0,.261-.009.523-.028.784-.029A1.288,1.288,0,0,1,5,124.847a1.3,1.3,0,0,1-1.047,1.394,1.978,1.978,0,0,1-.419.041c-.422-.005-.846,0-1.266-.038A2.551,2.551,0,0,1,0,123.678,5.332,5.332,0,0,1,.4,121.9a9.061,9.061,0,0,1,3.592-4.47c.279-.184.581-.333.877-.49.17-.09.172-.1.059-.262a8.23,8.23,0,0,1-.58-.892,5.019,5.019,0,0,1-.17-4.516,4.849,4.849,0,0,1,2.5-2.509,5.338,5.338,0,0,1,1.618-.457,1.258,1.258,0,0,1,1.339,1,1.219,1.219,0,0,1-.7,1.408,3.9,3.9,0,0,1-.592.187,2.551,2.551,0,0,0-.7,4.731,2.9,2.9,0,0,0,.886.313,1.265,1.265,0,0,1,1.025.889,1.3,1.3,0,0,1-1.1,1.646,3.247,3.247,0,0,0-.622.147c-.34.1-.69.171-1.025.286a6.17,6.17,0,0,0-2.277,1.364,7.539,7.539,0,0,0-.826.877,5.635,5.635,0,0,0-.947,1.873c-.048.167-.1.334-.143.5-.017.063-.022.129-.035.212",
    transform: "translate(-0.001 -96.673)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M109.508,6.483c.037.292.074.618.122.942a1.246,1.246,0,0,1-.508,1.308,1.232,1.232,0,0,1-1.87-.595,4.578,4.578,0,0,1-.235-1.218,6.212,6.212,0,0,1,.908-3.782A6.33,6.33,0,0,1,111.282.394,7.3,7.3,0,0,1,113.265,0a3.965,3.965,0,0,1,.6.037,6.536,6.536,0,0,1,1.8.4,7.146,7.146,0,0,1,2.229,1.411,5.415,5.415,0,0,1,1.338,1.935,7.61,7.61,0,0,1,.55,1.925,6.025,6.025,0,0,1,0,1.362c-.02.246-.065.491-.107.734a1.309,1.309,0,0,1-1.414,1.146,1.219,1.219,0,0,1-1.1-1.208,5.53,5.53,0,0,1,.086-.736A3.607,3.607,0,0,0,117.1,5.3a3.758,3.758,0,0,0-3.128-2.7,3.871,3.871,0,0,0-4.392,3.205c-.036.21-.043.426-.067.675",
    transform: "translate(-95.509 0)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M41.33,31.836a1.217,1.217,0,0,1-.691,1.135,2.43,2.43,0,0,1-.6.214,2.564,2.564,0,0,0-1.983,1.894,2.794,2.794,0,0,1-.249.631,1.215,1.215,0,0,1-1.484.514,1.236,1.236,0,0,1-.791-1.4,5.054,5.054,0,0,1,3.8-4.083,3.5,3.5,0,0,1,.772-.106,1.262,1.262,0,0,1,1.224,1.2",
    transform: "translate(-31.693 -27.345)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M245.71,30.669a3.847,3.847,0,0,1,1.182.278,5.457,5.457,0,0,1,2.356,1.758,4.309,4.309,0,0,1,.665,1.322,4.863,4.863,0,0,1,.245.928,1.235,1.235,0,0,1-.845,1.31,1.219,1.219,0,0,1-1.461-.536,2.433,2.433,0,0,1-.2-.5,3.323,3.323,0,0,0-.519-1.079,2.617,2.617,0,0,0-1.443-.927,1.777,1.777,0,0,1-.86-.409,1.18,1.18,0,0,1-.347-1.228,1.24,1.24,0,0,1,.984-.9,1.541,1.541,0,0,1,.245-.012",
    transform: "translate(-218.187 -27.376)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.cdba5b495de338ad71b0779bb63b66ae.svg";
export { ForwardRef as ReactComponent };